import React from 'react';
import AboutUs from './AboutUs';

function About() {
  return <AboutUs />;
}

export default About;
